import Modal from "react-bootstrap/Modal";
import "./Profile.scss";
import { ProfileDetailList } from "./Contant";
import React, { useContext } from "react";
import { ProfileContext } from "../../contexts/APIProvider";
import { getResponse } from "../../apis/util";

// Define Props for the Profile component
interface ProfileProps {
  open: boolean;
  handleClose: () => void;
}

// Define Profile Context Type
interface ProfileContextType {
  profile: Record<string, string | number | null>;
}

// Define User Details Type
interface UserDetailsType {
  [key: string]: string | number | null;
}

function Profile({ open, handleClose }: ProfileProps) {
  const { profile } = useContext(ProfileContext) as ProfileContextType;
  const userDetails: UserDetailsType = getResponse() ?? {};

  const ProfileTable = ProfileDetailList.map((item, index) => (
    <tr key={item.Details} className="profile-table-row">
      <th className="profile-table-label" scope="row">
        {item.Details}
      </th>
      <td className="profile-table-value">
        {profile?.[item.Details.toLowerCase()] ??
          userDetails?.[item.Details.toLowerCase()] ??
          "N/A"}
      </td>
    </tr>
  ));

  return (
    <Modal centered show={open} onHide={handleClose} className="profile-modal">
        <div className="modal-header">
          <h4 className="modal-title" id="profileModalTitle">
            Profile
          </h4>
        <button
          type="button"
          onClick={handleClose}
          className="modal-close-btn"
          aria-label="Close"
        >
              &times;
          </button>
        </div>

      <div className="modal-body">
        <table className="profile-table">
            <tbody>{ProfileTable}</tbody>
          </table>
        </div>

      <div className="profile-referral">
        <label htmlFor="referredBy" className="profile-referral-label">
          Referred By
        </label>
        <div className="profile-referral-row">
                <input
                  type="text"
            className="profile-referral-input"
                  id="referredBy"
                  placeholder="Enter username"
                  name="referredBy"
                />
          <button type="submit" className="profile-referral-submit">
                  Submit
                </button>
              </div>
            </div>

        <div className="modal-footer">
          <button
            type="button"
          className="profile-close-btn"
            onClick={handleClose}
          >
            Close
          </button>
      </div>
    </Modal>
  );
}

export default Profile;
